import { TLEData } from '../types/satellite';

/**
 * Parse TLE text data from CelesTrak or similar sources
 * Handles both 2LE (no name) and 3LE (with name) formats
 */
export function parseTLEText(tleText: string): TLEData[] {
  const lines = tleText
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);
  
  const satellites: TLEData[] = [];
  
  for (let i = 0; i < lines.length;) {
    // 2LE format: starts directly with '1 ' (no name line)
    if (lines[i].startsWith('1 ') && i + 1 < lines.length && lines[i + 1].startsWith('2 ')) {
      const line1 = lines[i];
      const line2 = lines[i + 1];
      // Use catalog number as fallback name
      const catalogNumber = line2.slice(2, 7).trim();
      const name = `SAT-${catalogNumber}`;
      
      satellites.push({ name, line1, line2 });
      i += 2;
    }
    // 3LE format: name + line1 + line2
    else if (
      i + 2 < lines.length &&
      lines[i + 1].startsWith('1 ') &&
      lines[i + 2].startsWith('2 ')
    ) {
      const name = lines[i];
      const line1 = lines[i + 1];
      const line2 = lines[i + 2];
      
      satellites.push({ name, line1, line2 });
      i += 3;
    }
    // Skip malformed entries
    else {
      console.warn(`Skipping malformed TLE entry at line ${i + 1}: ${lines[i]}`);
      i += 1;
    }
  }
  
  return satellites;
}

/**
 * Validate TLE line format
 */
export function validateTLE(tle: TLEData): boolean {
  try {
    // Basic format validation
    if (!tle.line1.startsWith('1 ') || !tle.line2.startsWith('2 ')) {
      return false;
    }
    
    // Check line lengths (TLE lines should be 69 characters)
    if (tle.line1.length !== 69 || tle.line2.length !== 69) {
      return false;
    }
    
    // Check catalog numbers match
    const catalog1 = tle.line1.slice(2, 7).trim();
    const catalog2 = tle.line2.slice(2, 7).trim();
    
    if (catalog1 !== catalog2) {
      return false;
    }
    
    return true;
  } catch {
    return false;
  }
}